import { useEffect } from 'react'

const ensureMetaTag = (selector, attributes) => {
    let node = document.head.querySelector(selector)
    if (!node) {
        node = document.createElement('meta')
        Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value))
        document.head.appendChild(node)
    }
    return node
}

const ensureCanonicalTag = () => {
    let link = document.head.querySelector('link[rel="canonical"]')
    if (!link) {
        link = document.createElement('link')
        link.setAttribute('rel', 'canonical')
        document.head.appendChild(link)
    }
    return link
}

function MetaData({
    title,
    description,
    keywords,
    canonicalUrl,
    ogTitle,
    ogDescription,
    ogImage,
    ogType = 'website',
    twitterCard = 'summary_large_image',
    robots = 'index,follow',
    structuredData,
    structuredDataId = 'page-structured-data'
}) {
    useEffect(() => {
        if (title) {
            document.title = title
        }

        if (description) {
            ensureMetaTag('meta[name="description"]', { name: 'description' }).setAttribute('content', description)
        }

        if (keywords) {
            ensureMetaTag('meta[name="keywords"]', { name: 'keywords' }).setAttribute('content', keywords)
        }

        ensureMetaTag('meta[name="robots"]', { name: 'robots' }).setAttribute('content', robots)

        ensureMetaTag('meta[property="og:title"]', { property: 'og:title' }).setAttribute('content', ogTitle || title || '')
        ensureMetaTag('meta[property="og:description"]', { property: 'og:description' }).setAttribute('content', ogDescription || description || '')
        ensureMetaTag('meta[property="og:type"]', { property: 'og:type' }).setAttribute('content', ogType)
        ensureMetaTag('meta[property="og:url"]', { property: 'og:url' }).setAttribute('content', canonicalUrl || window.location.href)

        if (ogImage) {
            ensureMetaTag('meta[property="og:image"]', { property: 'og:image' }).setAttribute('content', ogImage)
        }

        ensureMetaTag('meta[name="twitter:card"]', { name: 'twitter:card' }).setAttribute('content', twitterCard)
        ensureMetaTag('meta[name="twitter:title"]', { name: 'twitter:title' }).setAttribute('content', ogTitle || title || '')
        ensureMetaTag('meta[name="twitter:description"]', { name: 'twitter:description' }).setAttribute('content', ogDescription || description || '')

        if (ogImage) {
            ensureMetaTag('meta[name="twitter:image"]', { name: 'twitter:image' }).setAttribute('content', ogImage)
        }

        ensureCanonicalTag().setAttribute('href', canonicalUrl || window.location.href)

        let structuredDataNode
        if (structuredData) {
            structuredDataNode = document.getElementById(structuredDataId)
            if (!structuredDataNode) {
                structuredDataNode = document.createElement('script')
                structuredDataNode.id = structuredDataId
                structuredDataNode.type = 'application/ld+json'
                document.head.appendChild(structuredDataNode)
            }
            structuredDataNode.textContent = JSON.stringify(structuredData)
        }

        return () => {
            if (structuredDataNode && structuredDataNode.parentNode) {
                structuredDataNode.parentNode.removeChild(structuredDataNode)
            }
        }
    }, [
        title,
        description,
        keywords,
        canonicalUrl,
        ogTitle,
        ogDescription,
        ogImage,
        ogType,
        twitterCard,
        robots,
        structuredData,
        structuredDataId
    ])

    return null
}

export default MetaData
